import useStepFlow from "src/Modules/Hotels/hooks/useStepsFlow";
export default function WizardBody() {
  const { currentStepConfig } = useStepFlow();
  const Component = currentStepConfig?.Component;
  return Component ?? null;
}
